<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/abreu-vineyards')">Abreu Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/caymus-vineyards')">Caymus vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/christian-moueix-dominus')">Christian Moueix -
                        Dominus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/colgin-cellars')">Colgin Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/harlan-estates')">Harlan Estates
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/kapcsandy-winery')">Kapcsandy Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/opus-one')">Opus One
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/robert-mondovi-vineyards')">Robert Mondovi
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/scarecrow-wines')">Scarecrow Wines
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/napa/schrader-cellars')">Schrader Cellars
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/napa/screaming-eagle')">Screaming Eagle
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/napa')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Cantine Schrader</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Specializzata nella produzione di Cabernet Sauvignon californiani unici, le cantine Schrader hanno apparentemente fatto l'impossibile. La cantina è stata venduta ai marchi Constellation del colosso delle bevande ("eleviamo la vita con ogni bicchiere alzato") nel 2017 per l'enorme cifra di $ 60 milioni, ma non possiede una sola vite! Non sorprenderà chi segue il viavai delle aziende vinicole della Napa Valley, che si sono rivelate ottime opportunità di investimento sia che si tratti di acquistare una bottiglia o una tenuta.
                    </div>

                    <div class="howto-title2">Il (secondo) vino più costoso d'America</div>
                    <div class="howto-text">
                        Schader Cellars è particolarmente interessante in quanto un tempo era metà delle cantine Colgin-Schrader.
                        Il proprietario Fred Schrader sposò Ann Colgin e nel 1988 i due crearono l'omonima azienda vinicola. UN
                        alla prima, acclamatissima annata del 1992, seguì lo scioglimento del matrimonio (e
                        estate) nel 1998. Vent'anni dopo e Schrader rimane al top della forma, un film fisso su
                        La carta dei vini più costosa d'America (attualmente è secondo dietro a Screaming Eagle). Il successo
                        dei suoi vini ha molto a che fare con il suo viticoltore Thomas Rivers Brown, che Schrader ha individuato
                        mentre lavorava in un'enoteca locale. Schrader lo ha coinvolto nella produzione di
                        il suo vino (nonostante non abbia mai prodotto un Cabernet Sauvignon in vita sua), e la coppia sì
                        da allora sono rimasti inseparabili.
                        <br><br>
                        Fortunatamente, la cessione a Constellation non ha cambiato nulla nella squadra di Schrader, e tutto il resto
                        i membri del cast originale sono ancora presenti, incluso il noleggio a lungo termine di Beckstoffer
                        Vigneti, dove Schrader ottiene gran parte dei suoi frutti.
                    </div>

                    <div class="howto-title2">Un Nostradamus viticolo</div>
                    <div class="howto-text">
                        Fred Schrader è una specie di visionario quando si tratta dei suoi Cabernet Sauvignon. Squisitamente
                        intenso, Old Sparky (soprannome e prodotto premium di Schrader) costa fino a 500 € a bottiglia
                        al momento del rilascio e non è estraneo al punteggio di 100 punti Wine Advocate (raggiunto tre anni
                        in esecuzione in xxxx, xxxx e xxxx). L'unico altro vino a farlo è il suo secondo vino, Schrader
                        CCS (dal nome di sua moglie), che occupa il quinto posto nella lista dei vini più costosi d'America.
                        Schrader ha anche altri tre vini lì, ai numeri 13, 17 e 19, quindi basti dire, quando
                        considerando di investire in un vino della Napa Valley, Schrader è il re del Cabernet.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Schrader Cellars</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Schrader Cellars ist auf die Herstellung einzigartiger kalifornischer Cabernet Sauvignons spezialisiert und hat scheinbar das Unmögliche geschafft. Das Weingut wurde 2017 für satte 60 Millionen US-Dollar an den Getränkeriesen Constellation verkauft („Wir heben das Leben mit jedem erhobenen Glas“), besitzt aber keinen einzigen Weinstock! Dies wird niemanden überraschen, der das Kommen und Gehen der Weingüter im Napa Valley verfolgt, die sich als hervorragende Investitionsmöglichkeiten erwiesen haben, unabhängig davon, ob Sie eine Flasche oder ein Weingut kaufen.
                    </div>

                    <div class="howto-title2">Amerikas (zweit-) teuerster Wein</div>
                    <div class="howto-text">
                        Schader Cellars ist insofern besonders interessant, als es einst die Hälfte von Colgin-Schrader Cellars war.
                        Besitzer Fred Schrader heiratete Ann Colgin und 1988 gründeten die beiden ihr gleichnamiges Weingut. A
                        Dem ersten, hochgelobten Jahrgang 1992 folgte die Auflösung der Ehe (und
                        Nachlass) im Jahr 1998. Zwanzig Jahre später ist Schrader immer noch in Topform, ein regelmäßiger Bestandteil von
                        Amerikas teuerste Weinkarte (aktuell ist er Zweiter hinter Screaming Eagle). Der Erfolg
                        seiner Weine hat viel mit seinem Winzer Thomas Rivers Brown zu tun, den Schrader entdeckte
                        während er in einer örtlichen Weinhandlung arbeitete. Schrader holte ihn auf die Produktionsseite von
                        sein Wein (obwohl er in seinem Leben noch nie einen Cabernet Sauvignon hergestellt hatte), und das Paar hat es getan
                        blieben seitdem unzertrennlich.
                        <br><br>
                        Erfreulicherweise hat der Verkauf an Constellation nichts an Schraders Team verändert
                        Originaldarsteller sind immer noch vorhanden, einschließlich der Langzeitmiete von Beckstoffer
                        Weinberge, wo Schrader einen Großteil seiner Früchte bekommt.
                    </div>

                    <div class="howto-title2">Ein weinbaulicher Nostradamus</div>
                    <div class="howto-text">
                        Fred Schrader ist so etwas wie ein Visionär, wenn es um seine Cabernet Sauvignons geht. Exquisit
                        Der intensive Old Sparky (Schraders Spitzname und Premiumprodukt) kostet über 500 € pro Flasche
                        bei der Veröffentlichung und ist kein Unbekannter in der 100-Punkte-Bewertung des Wine Advocate (erreicht nach drei Jahren).
                        läuft in xxxx, xxxx und xxxx). Der einzige andere Wein, dem dies gelingt, ist sein Zweitwein, Schrader
                        CCS (benannt nach seiner Frau), das auf der teuersten Weinkarte Amerikas den fünften Platz belegt.
                        Schrader hat dort auch drei weitere Weine unter den Nummern 13, 17 und 19, es genügt also zu sagen, wann
                        Wenn man darüber nachdenkt, in einen Wein aus dem Napa Valley zu investieren, ist Schrader der Cabernet-König.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Caves Schrader</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Spécialisée dans la production de Cabernet Sauvignon californien uniques, Schrader Cellars a apparemment fait l'impossible. La cave a été vendue aux marques de boissons colosses Constellation ("nous élevons la vie avec chaque verre levé") en 2017 pour la modique somme de 60 millions de dollars, mais ne possède pas une seule vigne ! Cela ne surprendra personne qui suit les allées et venues des vignobles de Napa Valley, qui se sont révélés être d'excellentes opportunités d'investissement, que vous achetiez une bouteille ou un domaine.
                    </div>

                    <div class="howto-title2">Le (deuxième) vin le plus cher d'Amérique</div>
                    <div class="howto-text">
                        Schader Cellars est particulièrement intéressant en ce qu'il était autrefois la moitié de Colgin-Schrader Cellars.
                        Le propriétaire Fred Schrader a épousé Ann Colgin et en 1988, le duo a créé sa cave éponyme. UN
                        premier millésime très acclamé en 1992 a été suivi de la dissolution du mariage (et
                        succession) en 1998. Vingt ans plus tard et Schrader reste au top de sa forme, un reportage régulier sur
                        La carte des vins la plus chère d'Amérique (il est actuellement deuxième derrière Screaming Eagle). Le succès
                        de ses vins a beaucoup à voir avec son viticulteur Thomas Rivers Brown, que Schrader a repéré
                        alors qu'il travaillait dans un caviste local. Schrader l'a amené du côté de la production de
                        son vin (bien qu'il n'ait jamais fait de Cabernet Sauvignon de sa vie), et le couple a
                        resté inséparable depuis.
                        <br><br>
                        Heureusement, la vente à Constellation n'a rien changé à l'équipe de Schrader, et tous les
                        les acteurs originaux sont toujours présents, y compris la location à long terme de Beckstoffer
                        Vignobles, où Schrader tire une grande partie de ses fruits.
                    </div>

                    <div class="howto-title2">Un Nostradamus viticole</div>
                    <div class="howto-text">
                        Fred Schrader est une sorte de visionnaire quand il s'agit de ses Cabernet Sauvignons. Délicieusement
                        intense, Old Sparky (surnom de Schrader et produit premium) coûte plus de 500 € la bouteille
                        à sa sortie et n'est pas étranger au score de 100 points du Wine Advocate (obtenu trois ans
                        fonctionnant sous xxxx, xxxx et xxxx). Le seul autre vin à le faire est son second vin, Schrader
                        CCS (du nom de sa femme), qui occupe la cinquième place sur la carte des vins la plus chère d'Amérique.
                        Schrader a également trois autres vins là-bas, aux numéros 13, 17 et 19, il suffit donc de dire, quand
                        envisageant d'investir dans un vin de Napa Valley, Schrader est le roi du Cabernet.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Schrader Cellars</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Specialising in producing unique Californian Cabernet Sauvignons, Schrader Cellars have seemingly done the impossible. The winery was sold to drinks colossus Constellation brands (“we elevate life with every glass raised”) in 2017 for a whopping $60m, yet does not own a single vine! This will come as no surprise for anyone who follows the comings and goings of Napa Valley wineries, which have shown themselves to be excellent investment opportunities whether you are buying a bottle or an estate.
                    </div>

                    <div class="howto-title2">America’s (second) most expensive wine</div>
                    <div class="howto-text">
                        Schader Cellars is particularly interesting in that it was once half of Colgin-Schrader Cellars.
                        Owner Fred Schrader married Ann Colgin and in 1988 the duo created their eponymous winery. A
                        first, highly acclaimed vintage in 1992 was followed by the dissolution of the marriage (and
                        estate) in 1998. Twenty years on and Schrader remains on top form, a regular feature on
                        America’s most expensive wine list (currently he is second behind Screaming Eagle). The success
                        of his wines has much to do with his viticulturist Thomas Rivers Brown, whom Schrader spotted
                        whilst he was working in a local wine shop. Schrader brought him in on the production side of
                        his wine (despite never having made a Cabernet Sauvignon in his life), and the pair have
                        remained inseparable ever since.
                        <br><br>
                        Happily, the sale to Constellation has not changed anything in Schrader’s team, and all the
                        original cast members are still present, including the long term leasing of Beckstoffer
                        Vineyards, where Schrader gets much of his fruit.
                    </div>

                    <div class="howto-title2">A viticultural Nostradamus</div>
                    <div class="howto-text">
                        Fred Schrader is something of a visionary when it comes to his Cabernet Sauvignons. Exquisitely
                        intense, Old Sparky (Schrader’s nickname and premium product) costs upwards of €500 a bottle
                        upon release and is no stranger to the 100-point Wine Advocate score (achieved three years
                        running in xxxx, xxxx, and xxxx). The only other wine to do this is his second wine, Schrader
                        CCS (named after his wife), which holds fifth place on America’s most expensive wine list.
                        Schrader also has three other wines on there, at numbers 13, 17 and 19, so suffice to say, when
                        considering investing in a Napa Valley wine, Schrader is the Cabernet king.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SchraderCellars",
    head: {
        title: 'Schrader Cellars | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality of Schrader Cellars wine. Our expertly crafted, small-batch wines showcase the best of Napa Valley\'s terroir. Experience the exceptional flavors and aromas in every glass.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
            items: [
                {report: 'Abreu Vineyards', src: '/wine-guide/usa/napa/abreu-vineyards'},
                {report: 'Caymus vineyards', src: '/wine-guide/usa/napa/caymus-vineyards'},
                {report: 'Christian Moueix - Dominus', src: '/wine-guide/usa/napa/christian-moueix-dominus'},
                {report: 'Colgin Cellars', src: '/wine-guide/usa/napa/colgin-cellars'},
                {report: 'Harlan Estates', src: '/wine-guide/usa/napa/harlan-estates'},
                {report: 'Kapcsandy Winery', src: '/wine-guide/usa/napa/kapcsandy-winery'},
                {report: 'Opus One', src: '/wine-guide/usa/napa/opus-one'},
                {report: 'Robert Mondovi Vineyards', src: '/wine-guide/usa/napa/robert-mondovi-vineyards'},
                {report: 'Scarecrow Wines', src: '/wine-guide/usa/napa/scarecrow-wines'},
                {report: 'Schrader Cellars', src: '/wine-guide/usa/napa/schrader-cellars'},
                {report: 'Screaming Eagle', src: '/wine-guide/usa/napa/screaming-eagle'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
